import React from 'react'
import TrashManageSvg from 'images/modules/Manage/i-trash-strong.svg?raw'

export { default as TrashManageUrl } from 'images/modules/Manage/i-trash-strong.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: TrashManageSvg}} />
)
